import { isInvoiceBilled } from '../../constants/insuranceBilling';
import type {
  BillingSelectedItem,
  MutateSelectedFailure,
} from '../../hooks/useBillingCycles';
import { getBusinessErrorMessage } from '../../utils/apiErrorDetail';

/** A manual move back is shown once the selection holds an invoice row. */
export const hasInvoiceRow = (items: BillingSelectedItem[]) =>
  items.some(item => isInvoiceBilled(item.billType));

/**
 * Why a manual move is refused for this selection, naming the rows that do
 * not allow it, or undefined when every row does. A mixed selection is refused
 * whole, so the move never applies to part of it.
 */
export const manualMoveRefusal = (
  label: string,
  items: BillingSelectedItem[]
): string | undefined => {
  const refused = items.filter(item => !isInvoiceBilled(item.billType));
  if (refused.length === 0) return undefined;
  return `${label} is only available for invoice-billed claims. Remove: ${refused
    .map(item => item.name)
    .join(', ')}.`;
};

/** Toast the server's reason for each row a manual move refused. */
export const showManualMoveFailures = (
  failures: MutateSelectedFailure[],
  showError: (title: string, message: string) => void,
  title: string
) => {
  const lines = failures.map(
    failure =>
      `• ${failure.name}: ${
        getBusinessErrorMessage(failure.error) ?? 'It could not be updated.'
      }`
  );
  showError(title, lines.join('\n'));
};
